<template>
    <div>
        <div class="flex flex-col gap-2" :aria-invalid="props.error ? 'true' : undefined">
            <div
                @click="emit('update:marketing', !props.marketing)"
                data-test="marketing-type-card"
                class="flex items-center py-4 ps-4 pe-5 border border-solid rounded-xl cursor-pointer"
                :class="props.marketing ? 'bg-white border-sky-500' : 'bg-slate-50 border-slate-300'"
            >
                <vx-checkbox :modelValue="props.marketing" />
                <div class="ms-4">
                    <div class="text-slate-800 text-sm font-semibold leading-4">Marketing</div>
                    <ul
                        class="list-disc list-outside ms-4 mt-1 text-slate-500 text-xs"
                        v-html="audienceTypeDescription(AUDIENCE_TYPE_MARKETING)"
                    ></ul>
                </div>
            </div>
            <div
                @click="emit('update:transactional', !props.transactional)"
                data-test="transactional-type-card"
                class="flex items-center py-4 ps-4 pe-5 border border-solid rounded-xl cursor-pointer"
                :class="props.transactional ? 'bg-white border-sky-500' : 'bg-slate-50 border-slate-300'"
            >
                <vx-checkbox :modelValue="props.transactional" />
                <div class="ms-4">
                    <div class="text-slate-800 text-sm font-semibold leading-4">Transactional</div>
                    <ul
                        class="list-disc list-outside ms-4 mt-1 text-slate-500 text-xs"
                        v-html="audienceTypeDescription(AUDIENCE_TYPE_TRANSACTIONAL)"
                    ></ul>
                </div>
            </div>
        </div>
        <p v-if="props.error" class="mt-2 px-0.5 text-xs text-rose-800">
            {{ props.error }}
        </p>
    </div>
</template>

<script lang="ts" setup>
import { VxCheckbox } from '@voxie/frontend-components';
import { audienceTypeDescription, AUDIENCE_TYPE_MARKETING, AUDIENCE_TYPE_TRANSACTIONAL } from '~/constants/campaign';

const props = defineProps<{
    marketing: boolean;
    transactional: boolean;
    error?: string;
}>();

const emit = defineEmits<{
    (e: 'update:marketing', value: boolean): void;
    (e: 'update:transactional', value: boolean): void;
}>();
</script>
